export const CONFIG = 'CONFIG'				// 初始化数据
export const TEMPLATE = 'TEMPLATE'			// 装修模板数据
export const IS_LOGIN = 'IS_LOGIN'			// 登录态
export const USER_TOKEN = 'USER_TOKEN' // 用户token
export const USER_INFO = 'USER_INFO'		// 用户信息
export const SHARE_INFO = 'SHARE_INFO'		// 分享信息
export const AGENT_INFO = 'AGENT_INFO'		//分销商
export const USER_DATA = 'USER_DATA'		//用户相关信息
export const USER_AGREEMENT = 'USER_AGREEMENT'		//用户合同
export const CART_LIST = 'CART_LIST'		//购物车商品
export const CART_NUM = 'CART_NUM'			//购物车商品数
export const MESSAGE_IDS = 'MESSAGE_IDS'	// 小程序订阅消息模板ids
export const AUTH_TYPE = 'AUTH_TYPE'		// 授权模态框
export const PAGE_ROUTES = 'PAGE_ROUTES'	//路由表
export const ARTICLE = 'ARTICLE'	//文章列表



// WEBPACK FOOTER //
// ./src/vuex/types.js